import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timelapse-controls" }
const _hoisted_2 = { class: "controls-row" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "timeline-row" }
const _hoisted_5 = ["max", "value", "disabled"]
const _hoisted_6 = { class: "date-display" }
const _hoisted_7 = { class: "index-display" }

import { computed } from 'vue';
import { PlayIcon, PauseIcon, SkipBackIcon, SkipForwardIcon } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelapseControls',
  props: {
    isPlaying: { type: Boolean },
    currentDate: {},
    availableDates: {}
  },
  emits: ['toggle-play', 'prev', 'next', 'seek'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const totalFrames = computed(() => props.availableDates.length);
const currentFrameIndex = computed(() => {
    const idx = props.availableDates.indexOf(props.currentDate);
    return idx === -1 ? 0 : idx;
});

const currentDateFormatted = computed(() => {
    if (!props.currentDate) return 'Latest';
    const d = new Date(props.currentDate);
    return d.toLocaleDateString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' });
});

function onSliderInput(e: Event) {
    const val = Number((e.target as HTMLInputElement).value);
    const date = props.availableDates[val];
    if (date) {
        emit('seek', date);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "control-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('prev'))),
        title: "Precedente"
      }, [
        _createVNode(_unref(SkipBackIcon), { size: 20 })
      ]),
      _createElementVNode("button", {
        class: "control-btn play-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-play'))),
        title: __props.isPlaying ? 'Pausa' : 'Play'
      }, [
        (__props.isPlaying)
          ? (_openBlock(), _createBlock(_unref(PauseIcon), {
              key: 0,
              size: 24
            }))
          : (_openBlock(), _createBlock(_unref(PlayIcon), {
              key: 1,
              size: 24,
              align: "center",
              style: {"margin-left":"2px"}
            }))
      ], 8, _hoisted_3),
      _createElementVNode("button", {
        class: "control-btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next'))),
        title: "Successivo"
      }, [
        _createVNode(_unref(SkipForwardIcon), { size: 20 })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        type: "range",
        min: 0,
        max: totalFrames.value - 1,
        value: currentFrameIndex.value,
        onInput: onSliderInput,
        class: "timeline-slider",
        disabled: totalFrames.value <= 1
      }, null, 40, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(_toDisplayString(currentDateFormatted.value) + " ", 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(currentFrameIndex.value + 1) + " / " + _toDisplayString(totalFrames.value), 1)
    ])
  ]))
}
}

})